import React from 'react'
import { Button, Paper } from "@material-ui/core";
import { useStyles } from "./style";

interface CustomMuiPaperProps {
  showClose?: boolean; // Optional prop to show the close button
  [x: string]: any; // Allow other props
}
const CustomMuiPaper = ({ showClose, ...props }:CustomMuiPaperProps) => {
  const classes = useStyles();

  return (
    <Paper {...props} elevation={8}>
      {props.children}
      {showClose && (
        <div className={classes.closeButton}>
          <Button className={classes.closeContent}>
            Close
          </Button>
        </div>
      )}
    </Paper>
  );
};

export default CustomMuiPaper;